import { CategoryAdd,CategoryEdit,CategoryDel } from "@a/category.js";
import Cookies from "js-cookie"

//cookies
import { setToken, setUsername, getUsername, getToken, removeToken, removeUsername } from "../../utils/cookies";
const state ={
    token: "" || getToken(),
    username: "" || getUsername(),
}
const getters ={}
const mutations ={
    SET_TOKEN(state, value){ // 设置 token
        state.token = value;
        value && setToken(value);
    },
    SET_USERNAME(state, value){ // 设置用户名
        state.username = value;
        value && setUsername(value);
    },
}
const actions ={
    editAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CategoryEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    addAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CategoryAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            CategoryDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};